import { Map } from "lucide-react";
import type { CSSProperties } from "react";
import { chapterName, chapterNumbers, chapterSummary, progressSummary } from "../../engine";
import type { ChapterFilter } from "../../engine";
import { useGame } from "../../state/GameProvider";

interface ChapterMapProps {
  onSelect?: () => void;
}

export function ChapterMap({ onSelect }: ChapterMapProps) {
  const { state, actions } = useGame();
  const summary = progressSummary(state.progress);

  function handleJump(chapter: ChapterFilter) {
    actions.jumpChapter(chapter);
    onSelect?.();
  }

  return (
    <section className="panel chapter-panel">
      <div className="panel-title">
        <Map size={15} />
        章節地圖 · 二十篇
      </div>

      <button
        className={`chapter-all${state.chapter === "all" ? " sel" : ""}`}
        onClick={() => handleJump("all")}
      >
        全書
        <span>{`${summary.percent}%`}</span>
      </button>

      <div className="chapter-grid">
        {chapterNumbers.map((chapter) => {
          const cs = chapterSummary(state.progress, chapter);
          const clear = cs.total > 0 && cs.mastered === cs.total;
          return (
            <button
              key={chapter}
              className={`chapter-cell ch-${chapter}${state.chapter === chapter ? " sel" : ""}${clear ? " clear" : ""}`}
              style={{ "--chapter-progress": `${`${cs.gatePercent}%`}` } as CSSProperties}
              onClick={() => handleJump(chapter)}
              title={`${chapterName(chapter)} · 掌握 ${cs.mastered}/${cs.total}`}
            >
              <strong>{chapterName(chapter)}</strong>
              <span>{`${cs.gatePercent}%`}</span>
              <i className="cell-meter">
                <b style={{ width: `${`${cs.gatePercent}%`}` }} />
              </i>
            </button>
          );
        })}
      </div>

      <div className="chapter-total">
        <span>總體掌握度</span>
        <strong>{`${summary.percent}%`}</strong>
        <i className="meter">
          <b style={{ width: `${`${summary.percent}%`}` }} />
        </i>
      </div>
    </section>
  );
}
